import { useState, useEffect } from "react";


interface deviceIdResult {
    deviceId: string | null;
    isDeviceIdReady: boolean; // 토큰 준비 완료 여부
}

const useDeviceId = (): deviceIdResult => {
    const [deviceId, setDeviceId] = useState<string | null>(null);
    const [isDeviceIdReady, setIsDeviceIdReady] = useState<boolean>(false);

    useEffect(() => {

        const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent);


        window.sendDeviceId = (deviceId: string) => {
            if (!deviceId) return;
            setDeviceId(deviceId);
            setIsDeviceIdReady(true); // 디바이스 아이디 수신 완료
        };


        const tryRequestDeviceId = (retryCount = 0) => {
            if (isIos) {
                // iOS: webkit messageHandlers 주입 대기
                if (window.webkit?.messageHandlers?.nativeApp) {
                    window.webkit.messageHandlers.nativeApp.postMessage({ type: "getDeviceId" });
                } else if (retryCount < 10) {
                    setTimeout(() => tryRequestDeviceId(retryCount + 1), 300);
                } else {
                    console.warn("window.webkit.messageHandlers.getDeviceId을 찾을 수 없습니다.");
                    setIsDeviceIdReady(true);
                }
            } else {
                if (window.android?.getAosDeviceId) {
                    window.android.getAosDeviceId();
                } else if (retryCount < 10) {
                    setTimeout(() => tryRequestDeviceId(retryCount + 1), 300);
                } else {
                    console.warn("window.android를 찾을 수 없습니다.");
                    setIsDeviceIdReady(true); // 실패해도 블로킹 방지
                }
            }
        };

        if (isIos || window.android !== undefined) {
            // WebView 환경일 때만 토큰 요청
            tryRequestDeviceId();
        } else {
            // 일반 브라우저면 바로 완료 처리
            setIsDeviceIdReady(true);
        }

        return () => {
            delete window.sendDeviceId;
        };
    }, []);


    return { deviceId, isDeviceIdReady };
};

export default useDeviceId;